import React from 'react';

import { useAuthContext } from 'state/auth';

import { OnboardingCard } from './onboarding-card';

export const OnboardingCardContainer = () => {
  const { user } = useAuthContext();
  const showOnboarding = user?.details?.showThLoyaltyOnboarding;
  return showOnboarding ? <OnboardingCard /> : null;
};

export default OnboardingCardContainer;
